import classnames from 'classnames';
import React from 'react';
import styles from "./Skeleton.module.js";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const Skeleton = ({
  baseColor,
  glowColor,
  variant = 'text',
  block = false,
  width,
  height,
  size,
  lines = 1,
  loading = true,
  className,
  animated = true,
  children,
  ...cssProperties
}) => {
  if (!loading && children) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  if (variant === 'text') {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: new Array(lines).fill(0).map((_, key) => /*#__PURE__*/_jsx("div", {
        style: {
          '--skeleton-base': baseColor,
          '--skeleton-glow': glowColor,
          display: block ? 'block' : 'inline-block',
          width: width || '100%',
          ...cssProperties
        },
        className: classnames(styles.skeleton, className, {
          [styles.animated]: animated
        }),
        children: "\u200C"
      }, key))
    });
  }
  let containerStyles;
  if (variant === 'circle') {
    containerStyles = {
      width: size,
      height: size,
      borderRadius: '100%',
      ...cssProperties
    };
  } else {
    containerStyles = {
      width,
      height,
      display: 'block',
      ...cssProperties
    };
  }
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.skeleton, className, {
      [styles.animated]: animated
    }),
    style: {
      ...containerStyles,
      '--skeleton-base': baseColor,
      '--skeleton-glow': glowColor
    }
  });
};